const password = v =>
  !v ||
  (/[A-Z]/.test(v) &&
    /[a-z]/.test(v) &&
    /[0-9]/.test(v) &&
    /[^A-Za-z0-9]/.test(v) &&
    v.length >= 8);

export default password;
